import React, { useState, useEffect } from "react";
import { Row, Col, Button } from "react-bootstrap";
import DataEntryDetailsLeftPane from "../../components/dataEntryDetails/dataEntryComponents/DataEntryDetailsLeftPane"
import UploadProgressBars from '../../common/uploadProgressBars/UploadProgressBars'
import { connect } from "react-redux";
import "./ReadOnlyTransaction.scss";
import { clearReadOnlyTransactionRequest,
    getReadOnlyUserTasksSaga,
    updateReadOnlyUserTasksActionCreator,
    updateReadOnlyUserTaskCommentsActionCreator,
    createReadOnlyUserTaskCommentActionCreator,
    addNewReadOnlyTaskActionCreator,
    updateReadOnlyTaskActionCreator,
    deleteReadOnlyTransactionTaskActionCreator,
    updateReadOnlyTransactionNotes,
    uploadReadOnlyMultipleDocumentsActionCreator,
    getReadOnlyTransactionDocuments,
    postReadOnlyWPSToken,
    getHealthOrganizationsSearchRequest,
    putResendTransaction,
    getRejectOptions,
    getOutboundTemplateRequest,
    updateIsEscalated,
    clearUserLocksActionRequest
    } from "../../components/landingPage/LandingPageDucks";
import {getReadOnlyAuditTrailRequest} from "./ReadOnlyTransactionDucks";
import { getReadOnlyDocumentName } from "./getReadOnlyDocumentName";
import CloseIcon from '@material-ui/icons/Close';
import { documentURL } from '../../services/Network';
import { BillingFormconstants, FormConstants } from '../../components/dataEntryDetails/dataEntryComponents/DataEntryFieldsConstants';
import { reduxForm } from 'redux-form';
import {
    getUserGroupsActionCreator,
    getAssessmentResultsActionCreator,
    getReviewEntitiesActionCreator,
    getQAErrorsActionCreator,
    setPDFPageNumberActionCreator,
    setCurrentFileTypeActionCreator
} from "../../components/dataEntryDetails/DataEntryDetailsDucks";
import ButtonWithDropdown from "../buttonWithDropdown/ButtonWithDropdown";
import UploadFileModal from "../modal/UploadFileModal";
import PdfViewer from "../pdfViewer/PdfViewer";
import { Toaster } from "react-hot-toast";
import ResendPopup from "../resendPopup/ResendPopup";
import { FeatureFlagsType } from "../customTypes/FeatureFlagsType";
import {clearPreviousSearch, returnToSearchRequest} from "../../components/login/LoginPageDucks";
import TransactionIssue, { QaError } from "../../models/transactionIssue";
import { DocTypes } from "../constants/DocTypes";
import { Facility } from "../../components/dataEntryDetails/dataEntryComponents/DataEntryDetails";
import { DRUG, EntityTypeId, HIV, HPV, PSYC_MHLT, ReviewEntity, STD } from "../../models/assessment";
import { SensitiveInfoRelease, SensitiveInfoType } from "../../models/transaction";
import AuditData from "../../models/auditData";
import TransactionDocument from "../../models/document";


interface ReadOnlyTransactionProps{
    readOnlyTransactionDetails?: any,
    readOnlyFormState?: any,
    userTasks?: any,
    userTasksComments?: any,
    clearReadOnly?: Function,
    getUserTasks?: Function,
    updateUserTasks?: Function,
    updateUserTaskComments?: Function,
    createUserTaskComment?: Function,
    addNewTask?: Function,
    updateTask?: Function,
    deleteTransactionTask?: Function,
    transactionNotes?: any,
    updateTransactionNotes?: Function,
    transactionNoteTypes?: any,
    getAuditTrailData?: (transactionId: string) => void,
    auditTrail?: readonly AuditData[],
    formState?: any,
    getUserGroups?: Function,
    facilityId?: any,
    postWPSToken?: Function,
    uploadMultipleDocuments?: Function,
    wpsToken?: string,
    getTransactionDocuments: Function,
    uploadDocumentSuccess?: any,
    uploadDocumentFailure?: any,
    getQAFeatureFlagsRequest?: Function,
    featureFlags?: FeatureFlagsType,
    loadUnwaitedTx?: Function,
    resetDataEntryState?: Function,
    getHealthOrganizationsSearch?: Function,
    getRejectOptions?: Function,
    getOutboundTemplateRequest?: Function,
    updateIsEscalated?: Function,
    getAssessmentResults?: (transactionId: string) => void,
    getReviewEntities?: (transactionId: string) => void,
    reviewEntities?: ReviewEntity[],
    getQAErrors?: () => void,
    qaErrors?: QaError[],
    qaIssues?: TransactionIssue[],
    clearPreviousSearch?: Function,
    returnToSearch?: Function,
    previousSearchParameters?: string,
    previousSearchPage?: number,
    clearUserLocksActionRequest?: Function,
    setPageNumber?: Function,
    pageNumber?: number,
    currentFile?: string,
    setCurrentFileType?: Function,
    currentFileType?: string,
}

function ReadOnlyTransaction(props: ReadOnlyTransactionProps) {
    const close = () => {
        const values = props.formState?.values || { values: {} };
        sessionStorage.setItem("formValues", JSON.stringify(values));
        props.clearUserLocksActionRequest && props.clearUserLocksActionRequest();
        props.getHealthOrganizationsSearch && props.getHealthOrganizationsSearch(null, null, null, false);
        props.clearReadOnly && props.clearReadOnly();
        props.clearPreviousSearch?.();
    }

    const [documents, setDocuments] = useState<any>({});
    const [selectedDocument, setSelectedDocument] = useState<string | undefined>("")
    const [active, setActive] = useState(false);
    const [showAttachFilesModal, setShowAttachFilesModal] = useState<any>({ state: false });
    const [showResendModal, setShowResendModal] = useState<any>({ state: false });
    const [uploadProgress, setUploadProgress] = useState<any>({});
    const [iframeKey, setIframeKey] = useState<string | null>(null);
    const [userInteractTime, setUserInteractTime] = useState<Date>(new Date());

    const fileTypes = {
        REQ: { label: "Request Document", allowAppend: true, modalType: "request document", ListLabel: "Request", AllowOnArchive: false, AllowOnComplete: false, ListOrder: 1 },
        MED: {label: 'Medical Records', allowAppend: false, modalType:"medical records", ListLabel: "Medical Records", AllowOnArchive: false, AllowOnComplete: false, ListOrder: 2 },
        AUX: { label: "Auxiliary Document", allowAppend: true, modalType: "auxiliary document", ListLabel: "Auxiliary", AllowOnArchive: false, AllowOnComplete: false, ListOrder: 3 },
        INT: { label: 'Internal File', allowAppend: false, modalType: "internal records", ListLabel: "Internal", AllowOnArchive: true, AllowOnComplete: true, ListOrder: 4 },
        NOTE: { label: "Notifications", allowAppend: false, modalType: "notification document", ListLabel: "Notification", AllowOnArchive: false, AllowOnComplete: true, ListOrder: 5 },
        INVOICE: { label: "Invoice Document", allowAppend: false, modalType: "invoice document", ListLabel: "Invoice", AllowOnArchive: false, AllowOnComplete: true, ListOrder: 6 },
        OTHER: { label: "Other", allowAppend: false, modalType: "other", ListLabel: "Other", AllowOnArchive: false, AllowOnComplete: false, ListOrder: null },
        RELEASE: { label: 'Release File', allowAppend: false, modalType: "internal records", ListLabel: "Release", AllowOnArchive: true, AllowOnComplete: true, ListOrder: null },
        COVER: { label: "Cover Sheet", allowAppend: true, modalType: "Cover Sheet", ListLabel: "Cover", AllowOnArchive: true, AllowOnComplete: true, ListOrder: 7 },
    } as const;

    const annotationAllowed: boolean = props.currentFileType == DocTypes.QA &&
            props.readOnlyTransactionDetails?.aiProcessingCompleted &&
            !(props.readOnlyTransactionDetails.facility as Facility)?.prohibitTraining;

    const authorizedEntities: {readonly [key in EntityTypeId]?: boolean} = {
        [DRUG]: props.readOnlyTransactionDetails?.sensitiveInfo?.some(inf => inf.id == SensitiveInfoType.SubstanceAbuse && inf.stateID == SensitiveInfoRelease.Authorized),
        [STD]: props.readOnlyTransactionDetails?.sensitiveInfo?.some(inf => inf.id == SensitiveInfoType.Std && inf.stateID == SensitiveInfoRelease.Authorized),
        [PSYC_MHLT]: props.readOnlyTransactionDetails?.sensitiveInfo?.some(inf => inf.id == SensitiveInfoType.MentalHealth && inf.stateID == SensitiveInfoRelease.Authorized),
        [HIV]: props.readOnlyTransactionDetails?.sensitiveInfo?.some(inf => inf.id == SensitiveInfoType.HivAids && inf.stateID == SensitiveInfoRelease.Authorized),
        [HPV]: props.readOnlyTransactionDetails?.sensitiveInfo?.some(inf => inf.id == SensitiveInfoType.Std && inf.stateID == SensitiveInfoRelease.Authorized),
    };

    useEffect(() => {
        if(props.readOnlyTransactionDetails?.attributes?.facility && props.getRejectOptions){
            props.getRejectOptions(props.readOnlyTransactionDetails.attributes.facility.id)
        }
        if(props.getOutboundTemplateRequest){
            props.getOutboundTemplateRequest();
        }
        if (props.readOnlyTransactionDetails?.transactionId != null) {
            props.getAuditTrailData && props.getAuditTrailData(props.readOnlyTransactionDetails.transactionId);
        }
        setActive(props.readOnlyTransactionDetails != null)
    }, [props.readOnlyTransactionDetails, props.getRejectOptions, props.getOutboundTemplateRequest])

    useEffect(() => {

        if(!active){
            setSelectedDocument("");
            setDocuments({});
            }

    },[active]);

    useEffect(() => {

        if (props.readOnlyTransactionDetails?.documentList){
            const newDocuments = props.readOnlyTransactionDetails.documentList.reduce((acc, cur) => {
                (acc[cur.type.role] = acc[cur.type.role] || []).push(cur);
                return acc;
            },{});

            if (documentRefresh){
                const mostRecentDoc = props.readOnlyTransactionDetails?.documentList?.reduce((acc, cur) => {
                    return acc?.created?.date ?
                        new Date(acc.created.date) > new Date(cur.created.date) ? acc : cur :
                        cur;
                }, null);

                if (mostRecentDoc && new Date(mostRecentDoc.created.date) > userInteractTime){
                    setSelectedDocument(mostRecentDoc.id);
                }

            }

            const uris = Object.keys(fileTypes).reduce<string[]>((acc, cur) => {
                const u = newDocuments[cur]?.map(doc => doc.uri);
                if(u) acc.push(...u)
                return acc;
            }, [])

            newDocuments["OTHER"] = props.readOnlyTransactionDetails?.documentList.filter(doc => uris.indexOf(doc.uri) === -1 )

            if (props.featureFlags?.finalQAAccordions) {
                props.getAssessmentResults?.(props.readOnlyTransactionDetails.transactionId);
                props.getReviewEntities?.(props.readOnlyTransactionDetails.transactionId);
            }
            props.getQAErrors?.();

            setDocuments(newDocuments);
        }
    }, [props.readOnlyTransactionDetails?.documentList])

    const onReturnToSearch = () => {
        let organizationId = props.readOnlyTransactionDetails.attributes.transactionId?.split('-')?.[0];
        let requestBufferId = props.readOnlyTransactionDetails.attributes.transactionId?.split('-')?.[1];
        props.returnToSearch?.(organizationId && parseInt(organizationId), requestBufferId && parseInt(requestBufferId), props.previousSearchParameters, props.previousSearchPage);
    }

    const selectFile = (filename) => {
        setUserInteractTime(new Date());
        if(filename){
            setSelectedDocument(filename)
            if(selectedDocument === filename){
                resetIframeKey();
            }
        }else{
            setSelectedDocument(undefined)
        }
    }

    const getUserGroups = () =>{
        props.getUserGroups && props.getUserGroups(props.readOnlyTransactionDetails?.attributes?.facility?.id)
    }

    const attachSelect = (eventKey) => {
        if (eventKey.id === "a") {
            const m = {
                state: true,
                type: eventKey.type,
                ...fileTypes[eventKey.type],
                allowAppend: Object.keys(documents).indexOf(eventKey.type) === -1 || documents[eventKey.type].length === 0 ? false : fileTypes[eventKey.type].allowAppend
            };
            setShowAttachFilesModal(m)
        } else if (eventKey.id === "w") {
            props.postWPSToken && props.postWPSToken(props.readOnlyTransactionDetails.transactionId, eventKey.type);
        }
    }

    const hideAttachFilesModal = () => {
        setShowAttachFilesModal({ state: false, type: "", modalType: "" })
    }

    useEffect(() => {
        if (props.uploadDocumentSuccess && Object.keys(uploadProgress).length && Object.keys(uploadProgress).every(f => uploadProgress[f].loaded === 100)) {
            setUploadProgress(prev => ({}));
            selectFile(props.uploadDocumentSuccess.url);
            refreshDocuments();
        }
    }, [props.uploadDocumentSuccess?.fileID])

    const UploadProgressCreator = (fileId, filename) => (progress) => {
        let percentage = Math.floor((progress.loaded * 100) / progress.total)
        setUploadProgress(prev => ({
            ...prev,
            [fileId]: {
                name: filename,
                loaded: percentage
            }
        }));
    }

    const refreshDocuments = () => {
        props.getTransactionDocuments && props.readOnlyTransactionDetails && props.getTransactionDocuments(props.readOnlyTransactionDetails.transactionId);
    }

    const [documentRefresh, setDocumentRefresh] = useState<any>(null);

    useEffect(() => {
        if(selectedDocument){
            resetIframeKey();
        }
    },[selectedDocument])

    useEffect(() => {
        if (props.wpsToken && props.wpsToken != "") {
            window.open("verismawps:" + props.wpsToken, '_blank');
            const interval = setInterval(() => {
                refreshDocuments();
            }, 5000)

            setDocumentRefresh(interval);
            setUserInteractTime(new Date());

            return () => clearInterval(interval);
        }
    }, [props.wpsToken]);

    const uploadFiles = (files: any, append: boolean = false) => {
        hideAttachFilesModal();
        const requestObjs: any[] = [];
        const initProgress = {};
        Object.keys(files).forEach((fileKey: string, index: any) => {
            let requestObject = {
                fileName: files[fileKey].name,
                fileID: fileKey,
                recordType: files[fileKey]["fileType"],
                file: files[fileKey].file,
                transactionId: props.readOnlyTransactionDetails.transactionId,
                append: append,
                uploadProgress: UploadProgressCreator(fileKey, files[fileKey].name)
            }

            initProgress[fileKey] = { name: files[fileKey].name, loaded: 0 };

            requestObjs.push({ obj: requestObject });
        })

        setUploadProgress(prev => initProgress);
        process.nextTick(() => {
            requestObjs.forEach(o => props.uploadMultipleDocuments && props.uploadMultipleDocuments(o.obj));
        });

    }

    const resetIframeKey = () => {
        const key = Math.random().toString(36).substring(2, 6);
        setIframeKey(key);
    }

    const documentData = () => {
        const document = (props.readOnlyTransactionDetails?.documentList as TransactionDocument[])?.find(d => d.id === selectedDocument);
        if (document) {
            return {
                ...document,
                filePath: documentURL + selectedDocument + "/file?userid=" + global.userID + "&addTrailEntry=false"
            }
        }
    }

    const setIsEscalated = (state) => {
        props.updateIsEscalated && props.updateIsEscalated({
            isEscalated: state,
            transactionId: props.readOnlyTransactionDetails.transactionId,
            userID: global.userID
        });
        props.readOnlyTransactionDetails.attributes.isEscalated = state;
    }

    return props.readOnlyTransactionDetails ? (
        <div className="readOnlyBackdrop">
            <UploadProgressBars uploadProgress={uploadProgress} uploadDocumentFailure={props.uploadDocumentFailure} setUploadProgress={setUploadProgress} />
            <div className="readOnlyWindow">
                <Row className="readOnlyContainer">
                    <Col className="readOnlyLeftColumn col-4">
                        <DataEntryDetailsLeftPane
                            dataEntryFormState={{ values: props.readOnlyFormState, initial: props.readOnlyFormState}}
                            transactionId={props.readOnlyTransactionDetails.transactionId}
                            transactionDetails={props.readOnlyTransactionDetails.attributes}
                            userTasks={props.userTasks || []}
                            userTaskComments={props.userTasksComments || []}
                            resetForm={() => {}}
                            requestorBillingDetails={props.readOnlyTransactionDetails.billingDetails}
                            requestorDetails={props.readOnlyTransactionDetails.requestorDetails}
                            patientDetails={props.readOnlyTransactionDetails.patientDetails}
                            transactionNotes={props.transactionNotes}
                            transactionNoteTypes={props.transactionNoteTypes}
                            updateTransactionNotes={props.updateTransactionNotes}
                            updateUserTasks={props.updateUserTasks}
                            updateUserTaskComments={props.updateUserTaskComments}
                            createUserTaskComment={props.createUserTaskComment }
                            addNewTask={props.addNewTask}
                            updateTask={props.updateTask}
                            deleteTransactionTask={props.deleteTransactionTask }
                            closeReadOnlyModal={props.clearReadOnly}
                            getUserGroups={getUserGroups}
                            facilityId={props.facilityId}
                            auditTrail={props.auditTrail}
                            loadUnwaitedTx={props.loadUnwaitedTx}
                            setEscalation={setIsEscalated}
                            getQAFeatureFlagsRequest = {props.getQAFeatureFlagsRequest}
                            reviewEntities={props.reviewEntities}
                            qaErrors={props.qaErrors ?? []}
                            qaIssues={props.qaIssues ?? []}
                            setPageNumber={props.setPageNumber}
                            setCurrentFileType={props.setCurrentFileType}
                            currentFileType = {props.currentFileType}
                            pageNumber = {props.pageNumber}
                            currentFile = {props.currentFile}
                            authorizedEntities={authorizedEntities}
                            documentsList={props.readOnlyTransactionDetails.documentList}
                        />
                    </Col>
                    <Col className="readOnlyRightColumn col-8">
                        <div className="readOnlyRightTitle">
                            <div className="readOnlySelectContainer">
                                <select onChange={(event) => {
                                    selectFile(event.target.value)
                                }}>
                                    <option value={""}>Select File</option>
                                    {Object.keys(fileTypes).map(type => {
                                        return documents[type] && documents[type].length && (
                                            <optgroup label={fileTypes[type].label}>
                                                {documents[type].map((f: any, i) => (
                                                    <option value={f.id} id={i}
                                                            selected={f.id === selectedDocument}>{getReadOnlyDocumentName(f)}</option>
                                                ))}
                                            </optgroup>
                                        )
                                    })}
                                </select>
                            </div>
                            <div className="readOnlyAttachContainer">
                                <span className='upload attach-records dropup'>
                                    <ButtonWithDropdown
                                        drop='down'
                                        style={{marginTop: '-.5em'}}
                                        title={"Attach Documents"}
                                        onSelect={(event) => attachSelect(event)}
                                        items={Object.keys(fileTypes)
                                            .filter(key => fileTypes[key].ListOrder &&
                                                (props.readOnlyTransactionDetails.attributes.transactionStatus.id != 260 || fileTypes[key].AllowOnArchive) &&
                                                (props.readOnlyTransactionDetails.attributes.transactionStatus.id < 130 || fileTypes[key].AllowOnComplete))
                                            .sort((a, b) => fileTypes[a].ListOrder > fileTypes[b].ListOrder ? 1 : -1)
                                            .flatMap((key, i) => [
                                                    i === 0 ? null : {divider: true},
                                                    {optgroup: fileTypes[key].ListLabel},
                                                    {title: 'Attach Files', id: 'a', type: key},
                                                    {title: 'Web print / scan', id: 'w', type: key}
                                                ]
                                                    .filter(e => e)
                                            )
                                        }
                                    ></ButtonWithDropdown>
                                    {showAttachFilesModal.state && <UploadFileModal
                                        onClickSave={uploadFiles}
                                        type={showAttachFilesModal.modalType}
                                        handleClose={hideAttachFilesModal}
                                        showModal={showAttachFilesModal.state}
                                        allowAppend={showAttachFilesModal.allowAppend}
                                        states={props.readOnlyTransactionDetails?.facility?.billingStates ?? []}
                                        defaultState={props.readOnlyTransactionDetails?.facility?.address?.state}
                                    />}
                                </span>
                            </div>
                            {[240, 260].indexOf(props.readOnlyTransactionDetails.attributes.transactionStatus.id) > -1 && <div className="readOnlyResendContainer">
                                <Button onClick={() => setShowResendModal({state: true})}>Resend
                                    Transaction</Button>
                                {showResendModal.state && <ResendPopup
                                    transactionId={props.readOnlyTransactionDetails.transactionId}
                                    requestorId={props.readOnlyTransactionDetails.requestorDetails.requestorID}
                                    email={props.readOnlyTransactionDetails.requestorDetails?.requestorInfo?.email}
                                    selectedContactId={props.readOnlyTransactionDetails.requestorDetails?.requestorInfo?.id}
                                    onClose={() => setShowResendModal({state: false})}
                                />}
                            </div>}
                            <div className={"return-to-search"}>
                                {props.previousSearchParameters && <button
                                    onClick={() => onReturnToSearch()}
                                    className={"return-to-search-text"}
                                    type="button"
                                >
                                    <svg width="16" height="16" fill="currentColor"
                                         className="chevron-left" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd"
                                              d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
                                    </svg>
                                    Back To Search Results
                                </button>}
                            </div>
                            <div className="readOnlyCloseContainer">
                                <a className="readOnlyClose" onClick={close}><CloseIcon style={{fontSize: "48px"}}/></a>
                            </div>
                        </div>
                        <Row className="readOnlyDocContainer">
                            <PdfViewer
                                key={iframeKey}
                                fileData={documentData()}
                                currentFile={props.currentFile}
                                pageNumber={props.pageNumber!}
                                setPageNumber={props.setPageNumber}
                                transactionId={props.readOnlyTransactionDetails.transactionId}
                                getAuditTrailData={props.getAuditTrailData!}
                                annotationAllowed={annotationAllowed}
                                authorizedEntities={authorizedEntities}
                            />
                        </Row>
                    </Col>
                </Row>
            </div>
            <Toaster toastOptions={{
                  className: 'toast-notification',
                }}
                position="top-right" />
        </div>) :
        <></>;
}

const readOnlyReduxForm = reduxForm<{}, ReadOnlyTransactionProps>({
    form: FormConstants.READ_ONLY_FIELDS_FORM,
    destroyOnUnmount: false,
})(ReadOnlyTransaction)


function mapStateToProps(state: any, props: any) {
    const formState = {
        [FormConstants.GENETIC_INFORMATION]: state.landingPageState?.readOnlyTransactionDetails?.attributes?.sensitiveInfo?.find(i => i.name === FormConstants.GENETIC_INFORMATION)?.stateID === 1,
        [FormConstants.HIV]: state.landingPageState?.readOnlyTransactionDetails?.attributes?.sensitiveInfo?.find(i => i.name === FormConstants.HIV)?.stateID === 1,
        [FormConstants.MENTAL_HEALTH]: state.landingPageState?.readOnlyTransactionDetails?.attributes?.sensitiveInfo?.find(i => i.name === FormConstants.MENTAL_HEALTH)?.stateID === 1,
        [FormConstants.SUBSTANCE_ABUSE]: state.landingPageState?.readOnlyTransactionDetails?.attributes?.sensitiveInfo?.find(i => i.name === FormConstants.SUBSTANCE_ABUSE)?.stateID === 1,
        [FormConstants.STD]: state.landingPageState?.readOnlyTransactionDetails?.attributes?.sensitiveInfo?.find(i => i.name === FormConstants.STD)?.stateID === 1,
        [FormConstants.DISCLOSE_ALL_INFO]: state.landingPageState?.readOnlyTransactionDetails?.attributes?.sensitiveInfo?.every(i => i.stateID === 1),
        [FormConstants.DONT_DISCLOSE_ANY_INFO]: state.landingPageState?.readOnlyTransactionDetails?.attributes?.sensitiveInfo?.every(i => i.stateID === 0),
        [BillingFormconstants.BILL_TO_REQUESTOR_NAME]: state.landingPageState?.readOnlyTransactionDetails?.billingDetails?.requestorBillingLocation,
        [BillingFormconstants.BILL_TO_FIRST_NAME]: state.landingPageState?.readOnlyTransactionDetails?.billingDetails?.firstName,
        [BillingFormconstants.BILL_TO_LAST_NAME]: state.landingPageState?.readOnlyTransactionDetails?.billingDetails?.lastName,
        [BillingFormconstants.BILL_TO_ADDRESS_LINE1]: state.landingPageState?.readOnlyTransactionDetails?.billingDetails?.address?.address1,
        [BillingFormconstants.BILL_TO_ADDRESS_LINE2]: state.landingPageState?.readOnlyTransactionDetails?.billingDetails?.address?.address2,
        [BillingFormconstants.BILL_TO_CITY]: state.landingPageState?.readOnlyTransactionDetails?.billingDetails?.address?.city,
        [BillingFormconstants.BILL_TO_STATE]: state.landingPageState?.readOnlyTransactionDetails?.billingDetails?.address?.state,
        [BillingFormconstants.BILL_TO_EMAIL_ADDRESS]: state.landingPageState?.readOnlyTransactionDetails?.billingDetails?.email,
        [BillingFormconstants.BILL_TO_ZIP]: state.landingPageState?.readOnlyTransactionDetails?.billingDetails?.address?.zipCode,
        [BillingFormconstants.BILL_TO_PHONE]: state.landingPageState?.readOnlyTransactionDetails?.billingDetails?.phone,
        [BillingFormconstants.BILL_TO_FAX]: state.landingPageState?.readOnlyTransactionDetails?.billingDetails?.fax,
    }

    return {
        readOnlyTransactionDetails: state.landingPageState.readOnlyTransactionDetails,
        userTasks: state.landingPageState.userTasks,
        userTasksComments: state.landingPageState.userTasksComments,
        transactionNotes: state.landingPageState.transactionNotes,
        transactionNoteTypes: state.landingPageState.transactionNoteTypes,
        readOnlyFormState: formState,
        auditTrail: state.readOnlyTransactionState.auditTrail,
        formState: state.form && state.form[FormConstants.DATA_ENTRY_FIELDS_FORM],
        facilityId: state.landingPageState?.readOnlyTransactionDetails?.attributes.facility?.id,
        wpsToken: state.landingPageState.readOnlyTransactionDetails?.attributes?.wpsToken,
        uploadDocumentAPIStatus: state.landingPageState.readOnlyTransactionDetails?.attributes?.uploadDocumentAPIStatus,
        uploadDocumentFailure: state.landingPageState.readOnlyTransactionDetails?.attributes?.uploadDocumentFailure,
        uploadDocumentSuccess: state.landingPageState.readOnlyTransactionDetails?.attributes?.uploadDocumentSuccess,
        featureFlags: state.loginState.featureFlags,
        qaErrors: state.dataEntryState.getQAErrors,
        qaIssues: state.landingPageState.readOnlyTransactionDetails?.QAIssues,
        previousSearchParameters: state.loginState.previousSearchParameters,
        previousSearchPage: state.loginState.previousSearchPage,
        currentFileType: state.dataEntryState.currentFileType,
        pageNumber: state.dataEntryState.pageNumber,
        currentFile: state.dataEntryState.currentFile,
    };
}

export function mapDispatchToProps(dispatch: Function) {
    return {
        clearReadOnly: () => dispatch(clearReadOnlyTransactionRequest()),
        getUserTasks: (data: any) => dispatch(getReadOnlyUserTasksSaga(data)),
        updateUserTasks: (data) => dispatch(updateReadOnlyUserTasksActionCreator(data)),
        updateUserTaskComments: (data) => dispatch(updateReadOnlyUserTaskCommentsActionCreator(data)),
        createUserTaskComment: (data) => dispatch(createReadOnlyUserTaskCommentActionCreator(data)),
        addNewTask: (data) => dispatch(addNewReadOnlyTaskActionCreator(data)),
        updateTask: (data) => dispatch(updateReadOnlyTaskActionCreator(data)),
        deleteTransactionTask: (transactionId: string, usertaskId: string) => dispatch(deleteReadOnlyTransactionTaskActionCreator(transactionId, usertaskId)),
        updateTransactionNotes: (data: any) => dispatch(updateReadOnlyTransactionNotes(data)),
        getAuditTrailData: (transactionId: string) => dispatch(getReadOnlyAuditTrailRequest(transactionId)),
        getUserGroups: (facilityId: number) => dispatch(getUserGroupsActionCreator(facilityId)),
        postWPSToken: (transactionId, docType) => dispatch(postReadOnlyWPSToken(transactionId, docType)),
        uploadMultipleDocuments: (data: any) => dispatch(uploadReadOnlyMultipleDocumentsActionCreator(data)),
        getTransactionDocuments: (transactionId: string) => dispatch(getReadOnlyTransactionDocuments(transactionId)),
        getHealthOrganizationsSearch: (offset: number, limit: number, searchTerm: string, returnEmpty: boolean) => dispatch(getHealthOrganizationsSearchRequest(offset, limit, searchTerm, returnEmpty)),
        resendTransaction: (transactionId: string, contactId: number) => dispatch(putResendTransaction(transactionId, contactId)),
        getRejectOptions: (facilityId: number) => dispatch(getRejectOptions(facilityId)),
        getOutboundTemplateRequest: () => dispatch(getOutboundTemplateRequest()),
        updateIsEscalated:(data) => dispatch(updateIsEscalated(data)),
        getAssessmentResults: (transactionId: string) => dispatch(getAssessmentResultsActionCreator(transactionId)),
        getReviewEntities:(transactionId: string) => dispatch(getReviewEntitiesActionCreator(transactionId)),
        getQAErrors:() => dispatch(getQAErrorsActionCreator()),
        clearPreviousSearch: () => dispatch(clearPreviousSearch()),
        returnToSearch: (organizationId?: number, requestBufferId?: number, parameters?: string, page?: number) => dispatch(returnToSearchRequest(organizationId, requestBufferId, parameters, page)),
        clearUserLocksActionRequest: () => dispatch(clearUserLocksActionRequest()),
        setPageNumber: (pageNumber: number, fileDesc: string) => dispatch(setPDFPageNumberActionCreator(pageNumber, fileDesc)),
        setCurrentFileType: (fileType) => dispatch(setCurrentFileTypeActionCreator(fileType)),
    };
}

export default connect<{}, {}, ReadOnlyTransactionProps>(mapStateToProps, mapDispatchToProps)(readOnlyReduxForm);

//export default connect(mapStateToProps, mapDispatchToProps)(ReadOnlyTransaction);
